import { NON_FATF_COUNTRIES, getCustomerCountryName } from '../../../services/countriesService';

const sortedCountries = Array.from(NON_FATF_COUNTRIES).sort((a, b) =>
  getCustomerCountryName(a).localeCompare(getCustomerCountryName(b))
);

function NonFatfCountriesList(): JSX.Element {
  return (
    <>
      <span className="App-alert-text">Non FATF countries:</span>
      <div className="App-customer-country-list">
        <div className="App-country-checkboxes">
          {sortedCountries.map((code) => (
            <span key={code} className="App-country-readonly-item">
              {getCustomerCountryName(code)}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

export default NonFatfCountriesList;
